import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import { getAvailablePropertyTypes } from 'store/search/searchSelectors';
import { getQueryPropertyTypes } from 'store/search/searchSelectors/querySelectors';
import MultiSelectFilter from 'components/Filters/MultiSelectFilter';

const PropertyTypeFilter = ({ onChange, hideCount, displayClearFilter, onClearFilter }) => {
  const availablePropertyTypes = useSelector(getAvailablePropertyTypes);
  const selectedPropertyTypes = useSelector(getQueryPropertyTypes);

  return (
    <MultiSelectFilter
      title="Property Type"
      filterKey="propertyTypes"
      availableItems={availablePropertyTypes}
      selectedItems={selectedPropertyTypes}
      onChange={onChange}
      hideCount={hideCount}
      displayClearFilter={displayClearFilter}
      onClearFilter={onClearFilter}
      displayPlusIcon={true}
      data-testid="property-type-filter"
    />
  );
};

PropertyTypeFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  hideCount: PropTypes.bool,
  displayClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

PropertyTypeFilter.defaultProps = {
  hideCount: false,
  displayClearFilter: false,
  onClearFilter: noop,
};

export default PropertyTypeFilter;
